import { Toaster } from '@1trading/react/components/ui/toaster';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from '@/components/error-boundary';
import ScrollToTop from '@/components/ui/scroll-to-top';
import { initializeFirebaseAuth } from '@/lib/firebase/auth';
import ErrorPage from '@/pages/error';
import Providers from '@/providers';
import Routing from '@/routing';

import '@/lib/i18n';
import '@/index.css';

initializeFirebaseAuth();

const App = () => {
  return (
    <ErrorBoundary component={ErrorPage}>
      <Providers>
        <Router>
          <Routing />
          <ScrollToTop />
        </Router>
        <Toaster />
      </Providers>
    </ErrorBoundary>
  );
};
App.displayName = 'App';

export default App;
